/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Keep_Not_AddInputs */

const en_us2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't add`)
};

const pt_br2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não adicionar`)
};

const es_419_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No agregar`)
};

const pt_pt2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não adicionar`)
};

const fr_fr2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas ajouter`)
};

const de_de2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht hinzufügen`)
};

const it_it2_draft_keep_not_add = /** @type {(inputs: Draft_Keep_Not_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non aggiungere`)
};

/**
* | output |
* | --- |
* | "Don't add" |
*
* @param {Draft_Keep_Not_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_keep_not_add = /** @type {((inputs?: Draft_Keep_Not_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Keep_Not_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_keep_not_add(inputs)
	if (locale === "es-419") return es_419_draft_keep_not_add(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_keep_not_add(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_keep_not_add(inputs)
	if (locale === "de-DE") return de_de2_draft_keep_not_add(inputs)
	if (locale === "it-IT") return it_it2_draft_keep_not_add(inputs)
	return en_us2_draft_keep_not_add(inputs)
});
export { draft_keep_not_add as "draft.keep_not_add" }